<section class="mt-3">
  <kl-survey-submission-form
    [surveyId]="dialogData?.data?.surveyId"
    [userProfileKey]="dialogData?.data?.userProfileKey"
    [disableActions]="true">
  </kl-survey-submission-form>
</section>
